<template>
  <div>
    <base-header class="dashboard" type="">
      <div class="dashboard-stats">
        <div class="dashboard-stats-left">
          <h2>Statistiques</h2>
          <!--<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <ol class="breadcrumb breadcrumb-links">
              <li class="breadcrumb-item">
                <router-link :to="'/'"><i class="fas fa-home"></i></router-link>
              </li>
              <li class="breadcrumb-item">
                <a href="#">{{ $t("COMMON.DASHBOARD") }}</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Statistiques
              </li>
            </ol>
          </nav>-->
        </div>
        <div class="dashboard-stats-right">
          <!--<base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>-->
          <organization-selector
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
            @organizationChanged="
              (organizationId) => (selectedOrganization = organizationId)
            "
          />
          <auction-selector
            :placeholder="$t('COMMON.AUCTION')"
            :filterable="true"
            :showAll="false"
            :filterOrganization="selectedOrganization"
            @auctionChanged="
              (auctionId) => {
                selectedAuction = auctionId;
              }
            "
          />
        </div>
      </div>
      <!-- Card stats -->
      <div class="dashboard-cards">
        <div class="dashboard-cards-item total">
          <!-- Card body -->
          <div class="custom-card">
            <div class="custom-card-title">
              <h3>
                {{ $t("PROPERTIES.TOTAL_PROPERTIES") }}
              </h3>
            </div>
            <div class="custom-card-count">
              <span>
                {{ dashboardData.total_properties }}
              </span>
              <a
                @click="goToProperties('all')"
                class="text-nowrap text-white font-weight-600"
              >
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="dashboard-cards-item">
          <!-- Card body -->
          <div class="custom-card">
            <div class="custom-card-title">
              <h3>{{ $t("PROPERTIES.CONFIRMED_PROPERTIES") }}</h3>
            </div>
            <div class="custom-card-count">
              <span>
                {{ dashboardData.total_confirmed }}
              </span>
              <a
                @click="goToProperties('CONFIRMED')"
                class="text-nowrap text-white font-weight-600"
                ><i class="fas fa-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="dashboard-cards-item">
          <!-- Card body -->
          <div class="custom-card">
            <div class="custom-card-title">
              <h3>{{ $t("PROPERTIES.PENDING_PROPERTIES") }}</h3>
            </div>
            <div class="custom-card-count">
              <span>
                {{ dashboardData.total_pending }}
              </span>
              <a
                @click="goToProperties('PENDING')"
                class="text-nowrap text-white font-weight-600"
                ><i class="fas fa-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="dashboard-cards-item">
          <!-- Card body -->
          <div class="custom-card">
            <div class="custom-card-title">
              <h3>{{ $t("PROPERTIES.CANCELED_PROPERTIES") }}</h3>
            </div>
            <div class="custom-card-count">
              <span>
                {{ dashboardData.total_canceled }}
              </span>
              <a
                @click="goToProperties('CANCEL')"
                class="text-nowrap text-white font-weight-600"
                ><i class="fas fa-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="dashboard-cards-item">
          <!-- Card body -->
          <div class="custom-card">
            <div class="custom-card-title">
              <h3>{{ $t("PROPERTIES.PAYED_PROPERTIES") }}</h3>
            </div>
            <div class="custom-card-count">
              <span>
                {{ dashboardData.total_paid_properties }}
              </span>
              <a
                @click="goToProperties('PAIED')"
                class="text-nowrap text-white font-weight-600"
                ><i class="fas fa-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="dashboard-cards-item">
          <!-- Card body -->
          <div class="custom-card">
            <div class="custom-card-title">
              <h3>{{ $t("PROPERTIES.SOLDED_PROPERTIES") }}</h3>
            </div>
            <div class="custom-card-count">
              <span>
                {{ dashboardData.total_sold }}
              </span>
              <a
                @click="goToProperties('SOLD')"
                class="text-nowrap text-white font-weight-600"
                ><i class="fas fa-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="dashboard-charts">
      <div class="charts">
        <div class="charts-item">
          <div slot="header" class="charts-item-header">
            <span>{{ $t("COMMON.PROPERTIES") }}</span>
            <h4>
              {{ $t("COMMON.TOTAL") }}
            </h4>
          </div>
          <div class="charts-item-graph">
            <pie-chart
              ref="bigChart"
              :chart-data="propertiesChart.chartData"
              :extra-options="propertiesChart.extraOptions"
            >
            </pie-chart>
          </div>
        </div>
        <div class="charts-item">
          <div slot="header" class="charts-item-header">
            <span>{{ $t("COMMON.PROPERTIES") }}</span>
            <h4>{{ $t("PROPERTIES.TOTAL_OWED_TAXES") }}</h4>
          </div>
          <div class="charts-item-graph">
            <pie-chart
              ref="bigChart"
              :chart-data="taxesChart.chartData"
              :extra-options="taxesChart.extraOptions"
            >
            </pie-chart>
          </div>
        </div>
        <div class="charts-item">
          <div slot="header" class="charts-item-header">
            <span>{{ $t("COMMON.PROPERTIES") }}</span>
            <h4>{{ $t("PROPERTIES.TOTAL_FEES") }}</h4>
          </div>
          <div class="charts-item-graph">
            <pie-chart
              ref="bigChart"
              :chart-data="feesChart.chartData"
              :extra-options="feesChart.extraOptions"
            >
            </pie-chart>
          </div>
        </div>
      </div>
      <!-- End charts-->

      <!--Auctions-->
      <div class="auctions">
        <upcomming-auctions-table
          :items="
            dashboardData.upcomingAuctions &&
            dashboardData.upcomingAuctions.length > 0
              ? JSON.parse(JSON.stringify(dashboardData.upcomingAuctions))
              : []
          "
        ></upcomming-auctions-table>
      </div>

      <!--Organizations-->
      <div
        class="organizations"
        v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
      >
        <organizations-table
          :items="
            dashboardData.organizations &&
            dashboardData.organizations.length > 0
              ? JSON.parse(JSON.stringify(dashboardData.organizations))
              : []
          "
        ></organizations-table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import PieChart from "@/components/Charts/PieChart";

// Components
import BaseHeader from "@/components/BaseHeader";
import BaseProgress from "@/components/BaseProgress";

// Lists
import ProgressTrackList from "./ProgressTrackList";
import MembersCard from "@/views/Widgets/MembersCard";
import TaskList from "@/views/Widgets/TaskList";

// Tables
import OrganizationsTable from "./OrganizationsTable";
import UpcommingAuctionsTable from "./UpcommingAuctionsTable";
import VectorMapCard from "@/views/Widgets/VectorMapCard";
import organizations from "../../../../i18n/fr/organizations";

import OrganizationSelector from "@/components/OrganizationSelector.vue";
import AuctionSelector from "@/components/AuctionSelector";

export default {
  components: {
    LineChart,
    BarChart,
    PieChart,
    BaseHeader,
    BaseProgress,
    TaskList,
    VectorMapCard,
    OrganizationsTable,
    UpcommingAuctionsTable,
    ProgressTrackList,
    MembersCard,
    OrganizationSelector,
    AuctionSelector,
  },
  data() {
    return {
      loading: false,
      selectedOrganization: null,
      selectedAuction: null,
      dashboardData: {
        total_properties: 0,
        total_confirmed: 0,
        total_pending: 0,
        total_canceled: 0,
        total_sold: 0,
        total_paid_properties: 0,
      },
      bigLineChart: {
        chartData: {
          datasets: [
            {
              label: "Propriétés",
              data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
            },
          ],
          labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
      redBarChart: {
        chartData: {
          labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [
            {
              label: "Sales",
              data: [25, 20, 30, 22, 17, 29],
            },
          ],
        },
      },
      taxesChart: {
        chartData: null,
        extraOptions: {
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: true,
            position: "bottom",
            labels: {
              //boxWidth: 20,
              fontSize: 12,
              fontColor: "#1E1B39",
              fontFamily: "'Garet Variable', sans-serif",
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const value = dataset.data[tooltipItem.index];
                const total = dataset.data.reduce((a, b) => a + b, 0);
                const percentage = ((value / total) * 100).toFixed(1);
                const label = data.labels[tooltipItem.index];
                return `${label}: ${value} (${percentage}%)`;
              },
            },
          },
        },
      },
      feesChart: {
        chartData: null,
        extraOptions: {
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: true,
            position: "left",
            labels: {
              //boxWidth: 20,
              fontSize: 12,
              fontColor: "#1E1B39",
              fontFamily: "'Garet Variable', sans-serif",
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const value = dataset.data[tooltipItem.index];
                const total = dataset.data.reduce((a, b) => a + b, 0);
                const percentage = ((value / total) * 100).toFixed(1);
                const label = data.labels[tooltipItem.index];
                return `${label}: ${value} (${percentage}%)`;
              },
            },
          },
        },
      },
      propertiesChart: {
        chartData: null,
        extraOptions: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              display: true,
              position: "right",
              labels: {
                fontSize: 12,
                fontColor: "#1E1B39",
                fontFamily: "'Garet Variable', sans-serif",
              },
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const value = dataset.data[tooltipItem.index];
                const total = dataset.data.reduce((a, b) => a + b, 0);
                const percentage = ((value / total) * 100).toFixed(1);
                const label = data.labels[tooltipItem.index];
                return `${label}: ${value} (${percentage}%)`;
              },
            },
          },
        },
      },
    };
  },
  mounted() {
    this.fetchDashboardData();
  },
  watch: {
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedAuction: {
      handler: "getListDebounced",
      immediate: true,
    },
  },
  methods: {
    async fetchDashboardData() {
      const url = process.env.VUE_APP_API_BASE_URL;
      try {
        this.loading = true;
        const payload = {
          organization_id: this.selectedOrganization || null,
          auction_id: this.selectedAuction || null,
        };
        const response = await axios.post(`${url}/dashboard-data`, payload);
        // Stocker la réponse
        this.dashboardData = response.data;
        this.preparePieData(
          this.propertiesChart,
          this.dashboardData.properties_chart
        );
        this.preparePieData(
          this.taxesChart,
          this.dashboardData.total_owed_taxes,
          true
        );
        this.preparePieData(this.feesChart, this.dashboardData.all_fees, true);

        // Mettre à jour le graphique
        this.updateCharts();
      } catch (error) {
        console.error(
          "Erreur de récupération des données du dashboard :",
          error
        );
      } finally {
        this.loading = false;
      }
    },

    getListDebounced: _.debounce(function () {
      this.fetchDashboardData();
    }, 300),

    updateCharts() {
      const d = this.dashboardData;
      this.redBarChart.chartData.datasets[0].data = [
        d.total_confirmed,
        d.total_pending,
        d.total_canceled,
        d.total_sold,
        d.total_paid_properties,
      ];
    },
    generateColors(count) {
      const colors = [];

      for (let i = 0; i < count; i++) {
        const r = Math.floor(Math.random() * 200) + 30;
        const g = Math.floor(Math.random() * 200) + 30;
        const b = Math.floor(Math.random() * 200) + 30;
        colors.push(`rgba(${r}, ${g}, ${b}, 0.8)`);
      }

      return colors;
    },
    preparePieData(chartElement, chartData, currency = false) {
      const chartLabels = chartData.map((item) => item.item_label);
      const chartValues = chartData.map((item) => parseInt(item.item_value));
      const colors = this.generateColors(chartValues.length);

      chartElement.chartData = {
        labels: chartLabels,
        datasets: [
          {
            label: "Montants (CAD)",
            data: chartValues,
            backgroundColor: colors,
            borderWidth: 1,
          },
        ],
      };

      chartElement.extraOptions = {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true,
          position: "right",
          labels: {
            fontSize: 12,
            fontColor: "#1E1B39",
            fontFamily: "'Garet Variable', sans-serif",
          },
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const value = dataset.data[tooltipItem.index];
              const total = dataset.data.reduce((a, b) => a + b, 0);
              const percentage = ((value / total) * 100).toFixed(1);
              const label = data.labels[tooltipItem.index];

              // 👉 Si la devise est activée
              if (currency) {
                const formattedValue = new Intl.NumberFormat("fr-CA", {
                  style: "currency",
                  currency: "CAD",
                  minimumFractionDigits: 0,
                }).format(value);

                return `${label}: ${formattedValue} (${percentage}%)`;
              }

              // 👉 Sinon, juste le nombre normal
              return `${label}: ${value} (${percentage}%)`;
            },
          },
        },
      };
    },
    goToProperties(status) {
      this.$router.push({
        name: "List Properties",
        query: {
          status,
          ...(this.selectedOrganization && {
            organization: this.selectedOrganization,
          }),
          ...(this.selectedAuction && { auction: this.selectedAuction }),
        },
      });
    },
  },
};
</script>
<style></style>
